import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import CityPage from "@/pages/CityPage";
import ServicePage from "@/pages/ServicePage";
import SubServicePage from "@/pages/SubServicePage";
import GenericPage from "@/pages/GenericPage";
import FaqPage from "@/pages/FaqPage";
import ContattiPage from "@/pages/ContattiPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { PAGINE_GENERICHE } from "@/data/pagine_generiche";
import { tracciaConversioneTelefono, configuraNumeroConversione } from "@/data/citta";

function App() {
  useEffect(() => {
    // Attiva il phone_conversion_number su tutte le pagine (numero tracciato ovunque compaia)
    configuraNumeroConversione();
    // Traccia come conversione Google Ads ogni click su un link telefonico (tel:)
    const suClickTel = (e) => {
      const link = e.target.closest?.('a[href^="tel:"]');
      if (link) tracciaConversioneTelefono();
    };
    document.addEventListener("click", suClickTel, true);
    return () => document.removeEventListener("click", suClickTel, true);
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/citta/:slug" element={<CityPage />} />
          <Route path="/servizi/idraulico/perdita-acqua" element={<ServicePage slugFisso="perdita-acqua" />} />
          <Route path="/servizi/:cat/:sub" element={<SubServicePage />} />
          <Route path="/servizi/:slug" element={<ServicePage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/contatti" element={<ContattiPage />} />
          {Object.entries(PAGINE_GENERICHE).map(([slug, pagina]) => (
            <Route key={slug} path={`/${slug}`} element={<GenericPage pagina={pagina} slug={slug} />} />
          ))}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" theme="dark" />
    </AuthProvider>
  );
}

export default App;
